import { render, staticRenderFns } from "./RoundedCheck.vue?vue&type=template&id=477028fb&"
import script from "./RoundedCheck.vue?vue&type=script&lang=ts&"
export * from "./RoundedCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports